import Vue from "vue";
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


import sha1 from "sha1";

Vue.use(WechatPlugin);
Vue.use(AjaxPlugin);

export default {

wxShare: (obj, callback) => {
console.log(obj, callback);
if (obj) {
var title =
obj.title == undefined || obj.title == null ? "测试系统" : obj.title;
var link =
obj.link == undefined || obj.link == null
? window.location.href
: obj.link;
var desc =
obj.desc == undefined || obj.desc == null ? "测试系统" : obj.desc;
var imgUrl =
obj.imgUrl == undefined || obj.imgUrl == null
? "src/img/share.png"
: obj.imgUrl;
} else {
alert("请传分享参数");
}

Vue.wechat.onMenuShareTimeline({
title: title, // 分享标题
link: link, // 分享链接
desc: desc, // 分享描述
imgUrl: imgUrl, // 分享图标
success: function() {
callback && callback();

},
cancel: function() {

}
});

Vue.wechat.onMenuShareAppMessage({
title: title, // 分享标题
desc: desc, // 分享描述
link: link, // 分享链接
imgUrl: imgUrl, // 分享图标
type: "", // 分享类型,music、video或link，不填默认为link
dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
success: function() {

callback && callback();
},
cancel: function() {

}
});

Vue.wechat.onMenuShareQQ({
title: title, // 分享标题
desc: desc, // 分享描述
link: link, // 分享链接
imgUrl: imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});


Vue.wechat.onMenuShareQZone({
title: title, // 分享标题
desc: desc, // 分享描述
link: link, // 分享链接
imgUrl: imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});


Vue.wechat.onMenuShareWeibo({
title: title, // 分享标题
desc: desc, // 分享描述
link: link, // 分享链接
imgUrl: imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});
},
wxConfig: (isDebug, shareObj, callback) => {
function getUrl() {
var url = window.location.href;


var locationurl = url.split("#")[0];

console.log(locationurl);

return locationurl;
}
console.log(isDebug);

Vue.http
.get(
Vue.prototype.GLOBAL.BASE_URL +
"/api/v1/getTokenAndTicket?appid=wx826bc7a2f2c367ac"
)
.then(response => response.data.data)
.then(data => {

let ret = {
appId: "wx826bc7a2f2c367ac",
timestamp: parseInt(new Date().getTime() / 1000),
nonceStr: Math.random()
.toString(36)
.substr(2),
jsapi_ticket: data.ticket,
signature: "",
url: getUrl()
};
let string =
"jsapi_ticket=" +
ret.jsapi_ticket +
"&noncestr=" +
ret.nonceStr +
"&timestamp=" +
ret.timestamp +
"&url=" +
ret.url;
ret.signature = sha1(string);

var wxdata = {
debug: isDebug,
appId: ret.appId,
timestamp: ret.timestamp,
nonceStr: ret.nonceStr,
jsapi_ticket: ret.jsapi_ticket,
signature: ret.signature,
url: ret.url,
jsApiList: [

"getLocation",
"onMenuShareTimeline",
"onMenuShareAppMessage",
"onMenuShareQQ",
"onMenuShareWeibo",
"onMenuShareQZone",
"startRecord",
"stopRecord",
"onVoiceRecordEnd",
"playVoice",
"pauseVoice",
"stopVoice",
"onVoicePlayEnd",
"uploadVoice",
"downloadVoice",
"chooseImage",
"previewImage",
"uploadImage",
"downloadImage",
"translateVoice",
"getNetworkType",
"openLocation",
"getLocation",
"hideOptionMenu",
"showOptionMenu",
"hideMenuItems",
"showMenuItems",
"hideAllNonBaseMenuItem",
"showAllNonBaseMenuItem",
"closeWindow",
"scanQRCode",
"chooseWXPay",
"openProductSpecificView",
"addCard",
"chooseCard",
"openCard"
]
};



console.log(wxdata);

Vue.wechat.config(wxdata);
Vue.wechat.ready(function() {

Vue.wechat.miniProgram.getEnv(function(res) {
if (res.miniprogram) {
console.log("在小程序里");
sessionStorage.setItem("isSP", "true");

} else {
sessionStorage.setItem("isSP", "false");
console.log("不在小程序里");
}
});
Vue.wechat.onMenuShareTimeline({
title: shareObj.title, // 分享标题
link: shareObj.link, // 分享链接
desc: shareObj.desc, // 分享描述
imgUrl: shareObj.imgUrl, // 分享图标
success: function() {
callback && callback();

},
cancel: function() {

}
});

Vue.wechat.onMenuShareAppMessage({
title: shareObj.title, // 分享标题
link: shareObj.link, // 分享链接
desc: shareObj.desc, // 分享描述
imgUrl: shareObj.imgUrl, // 分享图标
type: "", // 分享类型,music、video或link，不填默认为link
dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
success: function() {

callback && callback();
},
cancel: function() {

}
});

Vue.wechat.onMenuShareQQ({
title: shareObj.title, // 分享标题
link: shareObj.link, // 分享链接
desc: shareObj.desc, // 分享描述
imgUrl: shareObj.imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});


Vue.wechat.onMenuShareQZone({
title: shareObj.title, // 分享标题
link: shareObj.link, // 分享链接
desc: shareObj.desc, // 分享描述
imgUrl: shareObj.imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});


Vue.wechat.onMenuShareWeibo({
title: shareObj.title, // 分享标题
link: shareObj.link, // 分享链接
desc: shareObj.desc, // 分享描述
imgUrl: shareObj.imgUrl, // 分享图标
success: function() {

callback && callback();
},
cancel: function() {

}
});
Vue.wechat.getLocation({
type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
success: function(res) {

console.log("获取微信定位成功！");





localStorage.setItem("lat", res.latitude);
localStorage.setItem("lng", res.longitude);
}
});
});
});
}
};



// WEBPACK FOOTER //
// ./src/assets/utils/wx.js